import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';

import withStyles from '@mui/styles/withStyles';

// core components
import AdminNavbar from '../md/components/Navbars/AdminNavbar.jsx';
import Footer from '../components/Footer.jsx';
import Sidebar from '../md/components/Sidebar/Sidebar.jsx';

import getAppropriateRoutes from '../routes.js';

import appStyle from '../assets/jss/crm/layouts/crmStyle.jsx';

import logo from '../assets/img/Alleva-Primary-White-Orang.svg';

const routes = getAppropriateRoutes('AllevaRep');

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileOpen: false,
      miniActive: false,
      color: 'allevaOrange',
      bgColor: 'slate',
      fixedClasses: 'dropdown',
    };
  }
  componentDidMount() {
    window.addEventListener('resize', () => this.resizeFunction());
  }
  componentWillUnmount() {
    window.removeEventListener('resize', () => this.resizeFunction());
  }
  componentDidUpdate(e) {
    if (e.history.location.pathname !== e.location.pathname) {
      this.refs.mainPanel.scrollTop = 0;
      if (this.state.mobileOpen) {
        this.setState({ mobileOpen: false });
      }
    }
  }
  handleColorClick = (color) => {
    this.setState({ color: color });
  };
  handleBgColorClick = (bgColor) => {
    this.setState({ bgColor: bgColor });
  };
  handleFixedClick = () => {
    if (this.state.fixedClasses === 'dropdown') {
      this.setState({ fixedClasses: 'dropdown show' });
    } else {
      this.setState({ fixedClasses: 'dropdown' });
    }
  };
  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };
  showFullScreen() {
    // return this.props.location.pathname !== "/u/full-screen-maps";
    return false;
  }

  showFooter(activeRoute) {
    return activeRoute ? !this.showFullScreen() && !activeRoute.excludeFooter : true;
  }

  getActiveRoute = (routes) => {
    const activeRoute = null;
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        const collapseActiveRoute = this.getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1) {
          return routes[i];
        }
      }
    }
    return activeRoute;
  };

  getRouteName = (route) => (route ? route.name : 'Alleva CRM');

  getInnerRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return this.getInnerRoutes(prop.views);
      }
      if (prop.layout === '/ar') {
        return <Route path={prop.layout + prop.path} component={prop.component} key={key} />;
      } else {
        return null;
      }
    });
  };

  sidebarMinimize() {
    this.setState({ miniActive: !this.state.miniActive });
  }

  resizeFunction() {
    if (window.innerWidth >= 960) {
      this.setState({ mobileOpen: false });
    }
  }

  render() {
    const { classes, ...rest } = this.props;
    const activeRoute = this.getActiveRoute(routes);
    const innerRoutes = this.getInnerRoutes(routes);
    const mainPanel =
      classes.mainPanel +
      ' ' +
      cx({
        [classes.mainPanelSidebarMini]: this.state.miniActive,
      });
    return (
      <div className={classes.wrapper}>
        <Sidebar
          routes={routes}
          logo={logo}
          handleDrawerToggle={this.handleDrawerToggle}
          open={this.state.mobileOpen}
          color={this.state.color}
          bgColor={this.state.bgColor}
          miniActive={this.state.miniActive}
          {...rest}
        />
        <div className={mainPanel} ref="mainPanel">
          <AdminNavbar
            sidebarMinimize={() => this.sidebarMinimize()}
            miniActive={this.state.miniActive}
            brandText={this.getRouteName(activeRoute)}
            handleDrawerToggle={this.handleDrawerToggle}
            {...rest}
          />
          {/* On the /maps/full-screen-maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
          {!this.showFullScreen() ? (
            <div className={classes.content}>
              <div className={classes.container}>
                <Switch>{innerRoutes}</Switch>
              </div>
            </div>
          ) : (
            <div className={classes.map}>
              <Switch>{innerRoutes}</Switch>
            </div>
          )}
          {!this.showFooter(activeRoute) ? <Footer fluid /> : null}
        </div>
      </div>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(appStyle)(Dashboard);
